import React, { useEffect, useState } from 'react';
import { Bar } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  LineElement,
  PointElement,
  Title,
  Tooltip,
  Legend
} from 'chart.js';

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  LineElement,
  PointElement,
  Title,
  Tooltip,
  Legend
);

const API = window.location.hostname === 'localhost'
  ? 'http://localhost:5000/api'
  : 'https://demo.myssa.net/api';

const Graph3 = ({ width = '100%', height = '400px' }) => {
  const [chartData, setChartData] = useState(null);

  useEffect(() => {
    fetch(`${API}/plan_reception_fournisseur`)
      .then(response => response.json())
      .then(rawData => {

        const data = rawData.map(row => {
          const { ID, Id, client_id, Client_id, ...rest } = row;
          return rest;
        });

        const labels = data.map(item => item.Horizon);
        const nbreLigne = data.map(item => item['Nbre de ligne']);
        const nbreCommande = data.map(item => item['Nbre de commande']);
        const target = data.map(item => item.Target);

        setChartData({
          labels,
          datasets: [
            {
              label: 'Target',
              data: target,
              borderColor: '#3b82f6',
              borderWidth: 2,
              fill: false,
              type: 'line',
              borderDash: [5, 5],
              zIndex: 3,
            },
            {
              label: 'Nbre de ligne',
              data: nbreLigne,
              borderColor: '#388e3c',
              borderWidth: 2,
              type: 'line',
              zIndex: 2,
            },
            {
              label: 'Nbre de commande',
              data: nbreCommande,
              borderColor: '#D32F2F',
              borderWidth: 1,
              type: 'line',
              pointRadius: 5,
              zIndex: 1,
            },
          ],
        });
      })
      .catch(error =>
        console.error('Erreur chargement plan_reception_fournisseur depuis PostgreSQL:', error)
      );
  }, []);

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      title: {
        display: true,
        text: 'Plan de Réception Fournisseur',
      },
      legend: {
        position: 'bottom',
      },
    },
    scales: {
      y: {
        beginAtZero: true,
        ticks: {
          stepSize: 1,
        },
      },
    },
  };

  return (
    <div style={{ width, height }}>
      {chartData ? (
        <Bar data={chartData} options={options} />
      ) : (
        <p>Chargement des données...</p>
      )}
    </div>
  );
};

export default Graph3;